
import Datos from '../data/users.js'

export const authenticationService = {
    login
};

function login(username, password) {
    let user_data =  Datos.data.find( el => el.username === username);
    if (user_data && user_data.password === password) return { user: user_data.name, avatar_color: user_data.avatar.color, avatar_name: user_data.avatar.name };
    return null;
}
